import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useContext } from "react";
import Contexto from "../context/Contexto";
import { useLocation } from "react-router-dom";
import MercadoPagoLite from "../components/MercadoPagoLite";
import "../assets/css/Carrito.css";
import Tarjetas from "../assets/statics/tarjetas.png";
import LogoMercadoPago from "../assets/statics/mercadopago.svg";
import "../assets/css/Home.css";
import "../assets/css/Login.css";
import Carita from "../assets/statics/ds-abreviado-logo.png";
import {
  PayPalScriptProvider,
  PayPalButtons,
  BraintreePayPalButtons,
} from "@paypal/react-paypal-js";
<div class="fc-title">DISPONIBLE</div>;
function Comprar(props) {
  const {
    seteos,

    cliente,
    loguearUsuario,
    mandarMensajes,
    dameMiCurso,
    productos,
  } = useContext(Contexto);
  const location = useLocation();
  const [totalPesos, setTotalPesos] = useState(0);
  const [totalDolar, setTotalDolar] = useState(0);
  const [totalBruto, setTotalBruto] = useState(0);
  const [descuentos, setDescuentos] = useState(0);
  const [armadoProductos, setArmadoProductos] = useState(0);
  const [producto, setProducto] = useState("");
  const [regalado, setRegalado] = useState("");
  const [productou, setProductou] = useState("");

  useEffect(() => {
    let path = location.pathname.split("/");
    let productoSeleccionado = productos.filter(
      (ite) => ite.url === `/${path[2]}`
    );
    setProducto(productoSeleccionado);
    var totaloco = 0;

    if (productoSeleccionado[0]) {
      if (path[2] == "club-mensual") {
        totaloco = productoSeleccionado[0].precio;
      } else {
        totaloco =
          productoSeleccionado[0].precio - productoSeleccionado[0].descuento;
      }
      setTotalPesos(totaloco);
    }
    if (productoSeleccionado[0]) {
      setTotalDolar(productoSeleccionado[0].dolar);
    }
  }, [productos]);

  useEffect(() => {
    console.log("cliente:", cliente);
    if (producto[0]) {
      setProductou(producto[0].url.slice(1));
    }
  }, [totalPesos]);
  const [palabraClave, setPalabraClave] = useState(0);
  /*eslint-disable */
  let totalAntesDescuento = 0;
  /*eslint-disable */
  let isOferta = false;
  let total = 0;
  let ahorro = 0;

  //Si no hay nada en carrito, me rajo al home
  const navigate = useNavigate();

  const handleCheck = (e) => {
    setRegalado(e.target.checked);
    if (e.target.checked) {
      mandarMensajes("Que bien vas a regalar esta compra.");
    } else {
      mandarMensajes("Uy, te arrepentiste... bueh");
    }
  };

  let dameCursos = () => {
    dameMiCurso({ pibe: cliente.uid, cursin: [productou] });
    mandarMensajes(
      `Gracias por tu compra! te agregué ${productou}, podés verlos en tus cursos ya mismo.`
    );
  };

  return (
    <>
      <section className="home ">
        <div className="soporteLogin">
          <div className="login">
            <div className="login__wrapper centradoCompra">
              <br />
              <br />
              <img className="caritaCompra" src={Carita} alt="" />
              <p className="titFelicitaciones">
                Estás a punto de comprar:
              </p>{" "}
              {producto[0] && producto[0].nombre}
              <br />
              {producto[0] && producto[0].url != "/club-mensual" ? (
                <>
                  {/* <del>${producto[0] && producto[0].precio}</del> */}
                  <h1 className="precioFinale">${totalPesos}</h1>
                  <h3 className="precioinfo">
                    {/* Ahorrás ${producto[0] && producto[0].descuento} <br /> */}
                    12 cuotas sin interés
                  </h3>
                  <p className="ofertainfo">
                    {producto[0] && producto[0].ofertaInfo}
                  </p>
                  <br />
                </>
              ) : (
                <>
                  <h1 className="precioFinale">${totalPesos}</h1>
                </>
              )}
              {cliente ? (
                <>
                  {producto[0] && producto[0].url == "/club-mensual" ? (
                    <>
                      <Link
                        className="btn btn-success mercado-mensual"
                        to="https://www.mercadopago.com.ar/subscriptions/checkout?preapproval_plan_id=2c93808488c354f60188c58098f400be"
                      >
                        COMPRAR CON MERCADO PAGO
                      </Link>
                      <img src={Tarjetas} alt="" />
                    </>
                  ) : (
                    <MercadoPagoLite
                      precio={totalPesos ? totalPesos : ""}
                      producto={productou}
                      nombre={cliente.nombre}
                      username={cliente.username}
                      img_prod={producto[0] ? producto[0].img_prod : ""}
                      uid={cliente.uid}
                      email={cliente.email}
                      carrito={producto[0] ? producto : []}
                      regalito={regalado}
                    ></MercadoPagoLite>
                  )}
                  <br />
                  <br />
                  <br />
                  {totalDolar > 0 &&
                  producto[0] &&
                  producto[0].url != "/club-mensual" ? (
                    <PayPalScriptProvider
                      options={{
                        "client-id":
                          "AeQoTBWx-TzhTl4IYcqymIHDKtAsQMShHuFzGypcApY2GdbaCCw6nEsMtOS40Be9ti1I0p2qXmtSu8sE",
                      }}
                    >
                      <br />
                      <p className="precioinfo">
                        Resto del mundo USD{totalDolar}
                      </p>
                      <br />
                      <PayPalButtons
                        createOrder={(data, actions) => {
                          return actions.order.create({
                            purchase_units: [
                              {
                                amount: {
                                  currency_code: "USD",
                                  value: totalDolar,
                                },
                              },
                            ],
                          });
                        }}
                        onApprove={(data, actions) => {
                          return actions.order.capture().then((details) => {
                            const name = details.payer.name.given_name;
                            mandarMensajes(`Transaction completed by ${name}`);
                            dameCursos();
                          });
                        }}
                        style={{ tagline: false }}
                      />
                    </PayPalScriptProvider>
                  ) : (
                    <>
                      <p className="precioinfo">
                        Resto del mundo USD{totalDolar}
                      </p>
                      <br />
                      <iframe
                        src="https://www.colorclub.online/suscripcion-con-paypal"
                        frameBorder="0"
                      ></iframe>
                    </>
                  )}
                </>
              ) : (
                <>
                  <br />
                  <br />
                  <Link to="/" className="formuBT">
                    {" "}
                    Logueate para sumarte
                  </Link>
                  <br /> <br />
                  <br />
                  <hr />
                </>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Comprar;
